import { IMenuItem } from '@platform500services/p500-ui-kit';
import { RbacPermissionsConstant } from '../../services/rbac/rbac-permissions.constant';

export const MENU_CONFIG: IMenuItem[] = [
  {
    title: $localize`:@@common.dashboard:Dashboard`,
    link: '/app/dashboard',
    icon: 'p500-ui-icon-home',
  },
  {
    title: $localize`:@@common.offers:Offers`,
    link: '/app/offers',
    icon: 'p500-ui-icon-tags',
    permission: RbacPermissionsConstant.PAGES_TABLE_OFFERS,
  },
  {
    title: $localize`:@@common.clicks:Clicks`,
    link: '/app/clicks',
    icon: 'p500-ui-icon-click',
    permission: RbacPermissionsConstant.PAGES_TABLE_CLICKS,
  },
  {
    title: $localize`:@@common.conversions:Conversions`,
    link: '/app/conversions',
    icon: 'p500-ui-icon-funnel',
    permission: RbacPermissionsConstant.PAGES_TABLE_CONVERSIONS,
  },
  {
    title: $localize`:@@common.affiliate_trackers:Affiliate Trackers`,
    link: '/app/affiliate-trackers',
    icon: 'p500-ui-icon-flow',
    permission: RbacPermissionsConstant.PAGES_TABLE_AFFILIATES_TRACKERS,
  },
  {
    title: $localize`:@@common.smart_links:Smart Links`,
    link: '/app/smart-links',
    icon: 'p500-ui-icon-link',
    permission: RbacPermissionsConstant.PAGES_TABLE_SMART_LINKS,
  },
  {
    title: $localize`:@@common.billing:Billing`,
    icon: 'p500-ui-icon-wallet',
    children: [
      {
        title: $localize`:@@common.payment_details:Payment Details`,
        link: '/app/billing/payment-info',
      },
      {
        title: $localize`:@@common.earnings:Earnings`,
        link: '/app/billing/finance-earnings',
        permission: RbacPermissionsConstant.PAGES_TABLE_INVOICES,
      },
      {
        title: $localize`:@@common.invoices:Invoices`,
        link: '/app/billing/finance-invoices',
        permission: RbacPermissionsConstant.PAGES_TABLE_INVOICES,
      },
      {
        title: $localize`:@@common.payments:Payments`,
        link: '/app/billing/finance-payments',
        permission: RbacPermissionsConstant.PAGES_TABLE_INVOICES,
      },
    ],
  },
  {
    title: $localize`:@@common.data_exporter:Data Exporter`,
    link: '/app/reporting',
    icon: 'p500-ui-icon-file-download',
    permission: RbacPermissionsConstant.PAGES_SPECIAL_REPORT_BUILDER,
  },
  {
    title: $localize`:@@common.drilldown_reports:Drilldown Reports`,
    link: '/app/drilldown',
    icon: 'p500-ui-icon-chart-02',
    permission: RbacPermissionsConstant.PAGES_SPECIAL_DRILLDOWN,
  },
  {
    title: $localize`:@@common.comparing_analytics:Comparing Analytics`,
    link: '/app/comparing-analytics',
    icon: 'p500-ui-icon-layout-05',
    permission: RbacPermissionsConstant.PAGES_SPECIAL_COMPARING_ANALYTICS,
  },
];
